import gql from 'graphql-tag';

export const CREATE_RENTAL_ITEMS_BOOKING = gql`
  mutation createRentalItemsBooking(
    $rentalItemsBooking: RentalItemsBookingInput!
  ) {
    createRentalItemsBooking(rentalItemsBooking: $rentalItemsBooking) {
      id
    }
  }
`;

export const UPDATE_RENTAL_ITEMS_BOOKING = gql`
  mutation updateRentalItemsBooking(
    $rentalItemsBooking: RentalItemsBookingInput!
  ) {
    updateRentalItemsBooking(rentalItemsBooking: $rentalItemsBooking) {
      id
    }
  }
`;
